import { NgModule } from '@angular/core';
import { EventService } from './event.service';

/**
 * Event Module.
 *
 * @exports
 * @class EventModule
 */
@NgModule({
  providers: [EventService]
})
export class EventModule {}
